import { Component } from '@angular/core'
import { ProfileComponent } from '@monorepo-channels/components/feature-porto-bank'

@Component({
	standalone: true,
	imports: [ProfileComponent],
	selector: 'porto-bank-profile-page',
	template: `<feature-porto-bank-profile />`,
})
export class ProfilePageComponent {}
